<template>
    <a-select :options="grapherList" v-bind="$attrs" v-model="grapherValue" v-on="$listeners"/>
</template>

<script>
    import cache from "../../../../utils/cache";
    import enums from "../../../../utils/enums";

    export default {
        name: "AlbumGrapher",
        props: {
          albumId: String,
          emptyText: {
            type: String,
            default: "",
          },
        },
        data() {
            return {
                grapherList: []
            }
        },
        computed: {
            grapherValue: {
                get() {
                    return this.$attrs.value ? this.$attrs.value : undefined;
                },
                set(value) {
                    this.$emit("input", value);
                }
            }
        },
        mounted() {
            const self = this;
            if (this.emptyText) {
              self.grapherList.push({value: "all", label: this.emptyText});
            }
            cache.v1.album.member
                .search(this.albumId)
                .then(res => {
                    res.data.filter(item => enums.Role.isGrapher(item["roles"])).forEach(member => {
                        let name = member.comment[enums.Role.Grapher] ? member.comment[enums.Role.Grapher]
                            : (member.user.name ? member.user.name : (member.user.nick ? member.user.nick : "匿名者"));
                        self.grapherList.push({value: member.id, label: `${member.user.mobile} / ${name}`});
                    });
                });
        },
    }
</script>
